import { render, staticRenderFns } from "./chronicle_footer.vue?vue&type=template&id=af977846&scoped=true"
import script from "./chronicle_footer.vue?vue&type=script&lang=js"
export * from "./chronicle_footer.vue?vue&type=script&lang=js"
import style0 from "./chronicle_footer.vue?vue&type=style&index=0&id=af977846&prod&scoped=true&lang=css"
import style1 from "./chronicle_footer.vue?vue&type=style&index=1&id=af977846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af977846",
  null
  
)

export default component.exports